import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { rgbToHex } from 'named-color-maps/rgbToHex';
export const makeCachedMap = (selectColor, id, colorList) => {
  const map = {
    id: id,
    entries: [],
    colorMap: {},
    nameMap: {},
    colors: []
  };
  colorList === null || colorList === void 0 ? void 0 : colorList.forEach(color => {
    const fullColor = _objectSpread({}, color);

    if (color.name) {
      const c = selectColor(color.name);

      if (c) {
        fullColor.color = rgbToHex(c);
      }
    } else if (color.color) {
      fullColor.name = color.color;
    }

    if (fullColor.name && fullColor.color) {
      map.entries.push(fullColor);
      const i = map.entries.length - 1;
      map.nameMap[fullColor.name] = i;
      map.colors.push(fullColor.color);
      map.colorMap[fullColor.color] = i;
    }
  });
  return map;
};